import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '@/components/Sidebar'
import { SocketProvider } from '@/context/SocketContext'
import { CallPanel } from '@/pages/Conversations/components/CallPanel'

export default function PrivateLayout() {
  const [expanded, setExpanded] = useState(false)

  return (
    <SocketProvider>
      <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
        <Sidebar expanded={expanded} onExpandedChange={setExpanded} />
        <div style={{ flex: 1, minWidth: 0, position: 'relative' }}>
          <CallPanel />
          <div
            style={{
              height: '100vh',
              overflowY: 'auto',
              backgroundColor: '#f5f6f7',
              transition: 'max-width 0.5s ease',
            }}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </SocketProvider>
  )
}
